<template>
    <div class="depart-index">
        <div class="main-content">
            <div class="tab-content-box clearfix">
                <div class="tab-content fl clearfix hand-shape" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.id)">
                    <div class="img-left fl">
                        <img :src="item.img" :alt="item.name" class="img-responsive">
                    </div>
                    <div class="img-right fr">
                        <div class="title txt_limit mb10">{{item.name}}</div>
                        <div class="describe txt_limit6">{{item.content}}</div>
                    </div>
                </div>
            </div>
            <el-col  :span="24" class="toolbar">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="alltotal">
                </el-pagination>
            </el-col>
        </div>
        
    </div>
</template>

<script>
import seoArgs from '../../utils/setSeoArgs';

export default {
    props: {

    },
    components: {
        
    },
    data() {
        return {
            page: 1,//重新获取的当前的页码
            alltotal:10,//总的数据
            pageSize:10,//每一条的页数是10
            dataList:[],
            short_name:this.$route.params.short_name,
        };
    },
    computed: {

    },
    created() {
        const officeSeoInfo = this.$cookies.get(this.api.cachePrex+'2') || {};
        officeSeoInfo.name = '科室介绍';
        seoArgs.setSeoArgs(officeSeoInfo);

        this.getList();
    },
    mounted() {

    },
    watch: {
        $route(to,from){
            this.short_name=to.params.short_name;
            sessionStorage.setItem('english_short_name',this.short_name);
            this.getList();
        }
    },
    methods: {
        getList(){
            this.$axios.post(this.api.department.index+'?perpage='+this.pageSize+'&page='+this.page,{},res =>{
                this.dataList=res.data;
                this.alltotal=Number(res.pageInfo.totalCount);
            });
        },
        goDetail:function(id){
            this.$router.push('/departDetail/'+this.short_name+'/'+id+'.html');
        },
        //页面改变
        handleCurrentChange(val) {
            this.page=val;
            this.getList();
        },
        //每页的页数改变
        handleSizeChange(val) {
            this.pageSize=val;
            this.getList();
        },
    },
};
</script>

<style scoped>
.tab-content-box{padding-top:40px;}
.tab-content{margin-right:20px;margin-bottom:20px;width:580px;height:220px;padding:20px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;}
.tab-content:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
.tab-content:nth-child(2n+0){margin-right:0;}
.tab-content .img-left{width:180px;height:180px;margin-right:20px;}
.tab-content .img-right{width:340px;}
.tab-content .img-right .title{font-size:18px;color:rgba(51,51,51,1);line-height:25px;}
.tab-content .img-right .describe{font-size:14px;line-height:24px;color:#333333;height:140px;}
</style>



// WEBPACK FOOTER //
// src/view/depart/index.vue